import styled from 'styled-components';

import { media } from '~src/styles/media-templates';
import { PeriodSelectorContainer } from '~src/modules/reports/reportsHeader/containers/ReportsHeader.sc';

export const FiltersRow = styled.div<{ $disabled?: boolean }>`
  border: 1px solid ${({ theme }) => theme.black.a1};
  border-left: 0;
  border-right: 0;
  padding: 0px 75px;
  display: flex;
  align-items: center;
  opacity: ${(p) => (p.$disabled ? 0.7 : 1)};
  pointer-events: ${(p) => (p.$disabled ? 'none' : 'unset')};
  ${media.tablet`
    padding: 0px 6px;
  `}
`;

export const AttrSelectorCol = styled.div`
  width: 345px;
  padding: 15px 15px 15px 0;
  border-right: 1px solid ${({ theme }) => theme.black.a1};
  flex: 0 0 auto;
`;

export const FilterCol = styled.div`
  padding: 15px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  flex: 0 0 auto;
`;

export const FilterTitle = styled.div`
  font-weight: 600;
`;

export const SelectorBox = styled.div<{ $inactive?: boolean; $show?: boolean }>`
  margin-top: 10px;
  margin-right: 20px;
  opacity: ${({ $inactive, $show }) => ($show ? 0 : $inactive ? 0.5 : 1)};
`;

export const ComparePeriodSelectorContainer = styled(PeriodSelectorContainer)`
  padding: 0;
`;
